import axios from "axios";
import { toast } from "react-toastify";

const baseURL =
  "http://ec2-13-42-42-219.eu-west-2.compute.amazonaws.com/v1";  // ""http://3.236.75.102/v1";

export class authAPI {
  constructor() {
    this.api = axios.create({
      baseURL: baseURL,
      // timeout: 3000,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      // withCredentials: true,
    });
  }

  signin = async (payload) => {
    let _url = "/login";
    let _payload = JSON.stringify(payload);

    return await this.api.post(_url, _payload);
  };

  signout = async (auth) => {
    let _url = "/logout";
    let _payload = JSON.stringify({
      access_token: auth.token.access_token,
      refresh_token: auth.token.refresh_token,
    });
    let _config = {
      headers: {
        Authorization: `Bearer ${auth.token.refresh_token}`,
      },
    };

    return await this.api.post(_url, _payload, _config);
  };

  signup = async (payload) => {
    let _url = "/register";
    let _payload = JSON.stringify(payload);

    return await this.api.post(_url, _payload);
  };

  refresh = async (payload, auth, setAuth) => {
    let _url = "/refresh_token";
    let _payload = JSON.stringify(payload);
    let _config = {
      headers: {
        Authorization: `Bearer ${auth.token.refresh_token}`,
      },
    };

    try {
      const response = await this.api.post(_url, _payload, _config);

      if (response.status === 200) {
        const { token } = response.data;

        setAuth((prev) => {
          return {
            ...prev,
            token,
          };
        });

        return true;
      } else {
        throw new Error("Something went wrong");
      }
    } catch (error) {
      if (error.response) {
        toast.error("There was an error signing in, contact support");
      } else {
        toast.error("Request timed out, please try again");
      }

      return false;
    }
  };
}

export default authAPI;
